import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_BASE } from '../config';

function sessionId() {
  try {
    let s = localStorage.getItem('track_session');
    if (!s) {
      s = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      localStorage.setItem('track_session', s);
    }
    return s;
  } catch {
    return 's-anon';
  }
}

function customerAuth() {
  try {
    const t = localStorage.getItem('customer_token');
    return t ? { Authorization: `Bearer ${t}` } : {};
  } catch {
    return {};
  }
}

function beacon(payload) {
  try {
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(API_BASE + '/track', blob);
      return true;
    }
  } catch {}
  return false;
}

/**
 * Silent visit tracker (storefront only, never /admin):
 * - page view on every route change (server resolves product/category/post)
 * - dwell time of the previous page via sendBeacon
 * - links the customer when logged in
 */
export default function Tracker() {
  const loc = useLocation();
  const prev = useRef({ path: null, t0: Date.now() });

  useEffect(() => {
    const full = loc.pathname + loc.search;
    if (loc.pathname.startsWith('/admin')) {
      prev.current = { path: null, t0: Date.now() };
      return;
    }
    const now = Date.now();
    // dwell of previous page
    if (prev.current.path && prev.current.path !== full) {
      const dur = Math.max(1, Math.round((now - prev.current.t0) / 1000));
      const p = { session: sessionId(), event: 'view', path: prev.current.path, duration: dur, device: window.innerWidth < 768 ? 'mobile' : 'desktop' };
      if (!beacon(p)) axios.post('/track', p, { headers: customerAuth() }).catch(() => {});
    }
    // view of the new page
    prev.current = { path: full, t0: now };
    const device = window.innerWidth < 768 ? 'mobile' : 'desktop';
    axios.post('/track', {
      session: sessionId(),
      event: 'view',
      path: full,
      referrer: document.referrer ? document.referrer.slice(0, 500) : undefined,
      device,
    }, { headers: customerAuth() }).catch(() => {});
  }, [loc.pathname, loc.search]);

  // last page dwell on tab close
  useEffect(() => {
    const onHide = () => {
      if (!prev.current.path || window.location.pathname.startsWith('/admin')) return;
      const dur = Math.max(1, Math.round((Date.now() - prev.current.t0) / 1000));
      beacon({ session: sessionId(), event: 'view', path: prev.current.path, duration: dur, device: window.innerWidth < 768 ? 'mobile' : 'desktop' });
    };
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') onHide(); });
    window.addEventListener('pagehide', onHide);
    return () => window.removeEventListener('pagehide', onHide);
  }, []);

  return null;
}
